import React from 'react';
import { LandingContainer } from '../../containers';

export const Landing = () => <LandingContainer />;
